import { INITIAL_CDN_PATH } from '@/constants/config';
import { DetailedPosition, Group, Position } from '@/interfaces/Menu';

/**
 * Gets the appropriate image URL from either Position or DetailedPosition
 * Handles both relative and absolute URLs by prepending CDN base URL when needed
 * @param position - The position object (either Position or DetailedPosition)
 * @returns The complete image URL
 */
export const getImageUrl = (position: Position | DetailedPosition): string | undefined => {
  let imageUrl: string | undefined;

  if ('mainImage' in position) {
    imageUrl = position.mainImage?.['720_720'];
  } else {
    imageUrl = position.imageUris?.['720_720'];
  }

  // If the URL is relative (starts with /), prepend the CDN base URL
  if (imageUrl && imageUrl.startsWith('/')) {
    return `${INITIAL_CDN_PATH}${imageUrl}`;
  }

  return imageUrl;
};

/**
 * Checks if a position requires selection based on its structure
 * @param position - The position object (either Position or DetailedPosition)
 * @returns True if selection is required, false otherwise
 */
export const hasSelectionRequired = (position: Position | DetailedPosition): boolean => {
  if ('groups' in position) {
    return position.groups && position.groups.length > 0;
  }
  return position.selectionRequired;
};

/**
 * Filters groups to exclude 'Main' group
 * @param groups - Array of groups to filter
 * @returns Filtered groups without 'Main' group
 */
export const filterNonMainGroups = (groups: Group[]) => {
  return groups.filter(group => group.name !== 'Main');
};
